<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div *ngIf="!hasPendingData && data != null">
    <div class="table-responsive">
        <table class="table table-striped table-sm table-bordered-no-cells">
            <thead class="thead-light">
                <ng-container
                    *ngIf="data.pillars.length > 1; else singlePillarTpl"
                >
                    <tr>
                        <th rowspan="2">{{ i18n._53_NAME | translate }}</th>
                        <th rowspan="2">
                            {{ i18n._800_SUPERGROUP_RANKING | translate }}
                        </th>
                        <th
                            [attr.colspan]="data.pillars.length"
                            class="text-center"
                        >
                            {{ i18n._801_PILLARS | translate }}
                        </th>
                    </tr>
                    <tr>
                        <th
                            class="text-center"
                            *ngFor="let i of data.pillars"
                            [title]="i.name"
                        >
                            {{ i.initials }}
                        </th>
                    </tr>
                </ng-container>
                <ng-template #singlePillarTpl>
                    <tr>
                        <th>{{ i18n._53_NAME | translate }}</th>
                        <th>{{ i18n._800_SUPERGROUP_RANKING | translate }}</th>
                        <th class="text-center">
                            {{ data.pillars[0].initials }}
                        </th>
                    </tr>
                </ng-template>
            </thead>
            <tbody>
                <tr *ngFor="let i of data.items">
                    <td>{{ i.username }}</td>
                    <td>{{ i.superGroupRank }}</td>
                    <td
                        class="text-center"
                        *ngFor="let j of i.pillarResults"
                    >
                        <cmps-icon
                            class="cmps-cdk-fill-green-100"
                            svgIcon="check-circle-outline"
                            *ngIf="j === PillarResult.POSITIVE"
                        ></cmps-icon>
                        <cmps-icon
                            class="cmps-cdk-fill-red-100"
                            svgIcon="close-circle-outline"
                            *ngIf="j === PillarResult.NEGATIVE"
                        ></cmps-icon>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="w-100 text-right">
        <button
            type="button"
            class="btn btn-primary"
            (click)="showDetails()"
        >
            {{ i18n._746_DETAILS | translate }}
        </button>
    </div>
</div>
